import { z } from 'zod';
export const AdminDashboardSummarySchema = z
    .object({
    providerCount: z.number(),
    segmentCount: z.number(),
    userCount: z.number(),
})
    .catchall(z.unknown());
//# sourceMappingURL=admin-dashboard.js.map